// Кнопка «Напечатать»: одна на все отчёты и бланки.
//
// Заведена 11.09.2026 по образцу соседней `ExportButton`, и по той же причине. До неё печать
// звали шесть мест подряд как `void напечатать()` — то есть отказ выбрасывался в пустоту.
// На рабочем столе это почти незаметно: диалог печати открывает сама система. На планшете
// печать — единственный нативный кусок продукта, и он умеет отказать словами («печать
// недоступна: окно ещё не готово», «не удалось напечатать»). С `void` человек нажимал бы и
// не видел ничего — а это худший отказ из возможных: неотличим от сломанной программы.

import { useState } from 'react';

import { RiPrinterLine } from '@remixicon/react';

import { напечатать } from '@/shared/desktop';
import { текстОшибки } from '@/shared/reports/текст-ошибки';
import * as Button from '@/shared/ui/button';
import * as Hint from '@/shared/ui/hint';

export function PrintButton({
  размер = 'xsmall',
  подпись = 'Напечатать',
  безЗначка = false,
  скрытьПриПечати = false,
}: {
  размер?: 'xsmall' | 'xxsmall';
  подпись?: string;
  /** Без значка принтера: там, где кнопка стоит в плотной строке рядом с текстом. */
  безЗначка?: boolean;
  /** Не показывать саму кнопку на бумаге: она часть экрана, а не документа. */
  скрытьПриПечати?: boolean;
}) {
  const [идёт, setИдёт] = useState(false);
  const [отказ, setОтказ] = useState<string | null>(null);

  async function печатать() {
    // Второе нажатие, пока система поднимает лист печати, на планшете отвечает «окно ещё не
    // готово» — то есть выглядит как отказ там, где всё в порядке.
    if (идёт) {
      return;
    }
    setОтказ(null);
    setИдёт(true);
    try {
      await напечатать();
    } catch (ошибка) {
      const текст = текстОшибки(ошибка, 'система не открыла печать');
      setОтказ(`Не напечаталось: ${текст}. Повторите — если не поможет, скажите администратору.`);
    } finally {
      setИдёт(false);
    }
  }

  return (
    <div className='flex flex-col items-start gap-1'>
      <Button.Root
        type='button'
        variant='neutral'
        mode='stroke'
        size={размер}
        {...(скрытьПриПечати ? { 'data-печать': 'скрыть' } : {})}
        onClick={() => void печатать()}
      >
        {безЗначка ? null : <Button.Icon as={RiPrinterLine} />}
        {подпись}
      </Button.Root>
      {отказ === null ? null : <Hint.Root>{отказ}</Hint.Root>}
    </div>
  );
}
